import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2, ChevronLeft } from "lucide-react";

export default function SignupVerify() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [state, setState] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMessage("Token tidak ditemukan."); return; }
    api.get(`/auth/signup/verify?token=${encodeURIComponent(token)}`)
      .then((r) => { setState("success"); setMessage(r.data?.message || "Email berhasil dikonfirmasi."); })
      .catch((err) => { setState("error"); setMessage(err?.response?.data?.detail || "Gagal verifikasi."); });
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-paper to-terra-50/30 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white border border-stone-200 shadow-sm p-8 text-center" data-testid="signup-verify">
        {state === "loading" && (<>
          <Loader2 className="h-8 w-8 text-stone-400 animate-spin mx-auto mb-3" />
          <p className="text-sm text-stone-500">Memverifikasi email…</p>
        </>)}
        {state === "success" && (<>
          <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto mb-3" />
          <h1 className="font-display text-2xl font-bold text-stone-900 mb-2">Email Terkonfirmasi</h1>
          <p className="text-sm text-stone-600 leading-relaxed">{message}</p>
        </>)}
        {state === "error" && (<>
          <XCircle className="h-10 w-10 text-red-600 mx-auto mb-3" />
          <h1 className="font-display text-2xl font-bold text-stone-900 mb-2">Verifikasi Gagal</h1>
          <p className="text-sm text-stone-600 leading-relaxed">{message}</p>
        </>)}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-xs uppercase tracking-wider text-terra-700 hover:underline" data-testid="verify-back-login">
          <ChevronLeft className="h-3 w-3" /> Kembali ke Login
        </Link>
      </div>
    </div>
  );
}
